const compare = require('./compare')
const eq = (a, b, loose) => compare(a, b, loose) === 0
module.exports = eq



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/eq.js
// module id = 144
// module chunks = 0